import { buildApiUrl } from "../config/api";
import { clearAdminSession, getAdminAccessToken } from "../utils/authStorage";

export const TESTIMONIALS_CHANGED_EVENT = "testimonials:changed";

async function parseResponse(response) {
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = payload?.message || "Request failed.";
    const error = new Error(message);
    error.statusCode = response.status;
    throw error;
  }

  return payload;
}

async function request(pathname, options = {}) {
  const {
    method = "GET",
    body,
    requireAuth = false
  } = options;

  const headers = {
    "Content-Type": "application/json"
  };

  if (requireAuth) {
    const token = getAdminAccessToken();
    if (!token) {
      const error = new Error("Session expired. Please login again.");
      error.statusCode = 401;
      throw error;
    }
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(buildApiUrl(pathname), {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  });

  try {
    return await parseResponse(response);
  } catch (error) {
    if (error.statusCode === 401 && requireAuth) {
      clearAdminSession();
    }
    throw error;
  }
}

function notifyChanged() {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new Event(TESTIMONIALS_CHANGED_EVENT));
}

export async function initializeTestimonials() {
  return getTestimonials();
}

export async function getTestimonials() {
  const payload = await request("/testimonials");
  return Array.isArray(payload?.data) ? payload.data : [];
}

export async function addTestimonial(payload) {
  const response = await request("/admin/testimonials", {
    method: "POST",
    body: payload,
    requireAuth: true
  });
  notifyChanged();
  return response?.data || null;
}

export async function updateTestimonial(id, payload) {
  const response = await request(`/admin/testimonials/${id}`, {
    method: "PUT",
    body: payload,
    requireAuth: true
  });
  notifyChanged();
  return response?.data || null;
}

export async function deleteTestimonial(id) {
  await request(`/admin/testimonials/${id}`, {
    method: "DELETE",
    requireAuth: true
  });
  notifyChanged();
  return { id };
}

export async function clearTestimonialsStorage() {
  return Promise.resolve();
}
